import { getCmsServerEnvironment } from 'src/reusable/CmsServerEnvironmentHelper';
import { removeAllCache } from '../reusable/CacheHelper';

export const CmsUserRoleType = Object.freeze({
  CmsAdmin: { type: 'InternalCmsAdmin', name: 'Cms Admin' },
  CmsTeamLead: { type: 'InternalCmsTeamLead', name: 'Cms Team Lead' },
  CmsUser: { type: 'InternalCmsUser', name: 'Cms User' },
  CmsSuperUser: { type: 'InternalCmsSuperUser', name: 'Cms Super User' },
  CmsSalesUser: { type: 'InternalCmsSalesUser', name: 'Cms Sales User' },
  CmsSalesAdmin: { type: 'InternalCmsSalesAdmin', name: 'Cms Sales Admin' },
  CmsCustomerSuccessUser: {
    type: 'InternalCmsCustomerSuccessUser',
    name: 'Cms Customer Success User'
  }
});

export const bounceToLogin = () => {
  logout();
};

export function isUserRoleInclude(roleType, user) {
  if (user == null) {
    console.warn('[isUserRoleInclude] Warning: no user token received.');
    return false;
  }

  const namespace = getCmsServerEnvironment().auth0Namespace;
  const roleString = user[namespace + 'roles'];

  if (roleString == null) return false;

  const roles = JSON.parse(roleString);

  return roles.includes(roleType.type);
}

export const logout = () => {
  removeAuthLocalStorage();

  window.location.href = '/';

  return true;
};

export function removeAuthLocalStorage() {
  localStorage.removeItem('user');
  localStorage.removeItem('userRoles');
  localStorage.removeItem('token');
  localStorage.removeItem('lastUserInfoUpdateAtTimestamp');
  removeAllCache();
}

function storeCmsUserData(cmsUserPayload) {
  // Set User Info
  localStorage.setItem('user', JSON.stringify(cmsUserPayload));

  const namespace = getCmsServerEnvironment().auth0Namespace;
  const roleString = cmsUserPayload[namespace + 'roles'];

  let roles = [];
  if (roleString != null)
    roles = JSON.parse(cmsUserPayload[namespace + 'roles']);

  // SetRole
  localStorage.setItem('userRoles', JSON.stringify(roles));

  // User Info Refresh time
  localStorage.setItem('lastUserInfoUpdateAtTimestamp', Date.now().toString()); // timestamp with number type
}

export function GetInternalId(userDetails) {
  if (
    userDetails !== undefined &&
    userDetails.app_metadata !== undefined &&
    userDetails.app_metadata.sleekflow_id !== undefined
  ) {
    console.log(userDetails.app_metadata.sleekflow_id);
    return userDetails.app_metadata.sleekflow_id;
  }

  return '';
}
